import numeral from "numeral";
import dayjs from "dayjs";
import ConfigTextInput from "../views/pages/store/config/ConfigTextInput";
import ConfigRadio from "../views/pages/store/config/ConfigRadio";
import ConfigCombo from "../views/pages/store/config/ConfigCombo";

export function currencyFormatter(params) {
  return numeral(params.value).format("0,0");
}

/*export function onlyNumberFormatter(params) {
    return numeral(params.value).replace(/[^0-9]/g, "");
}*/

export function timeFormatter(params, dataFormat, resultFormat) {
  try {
    const isValid = dayjs(params.value, dataFormat, true).isValid();
    if (isValid) {
      return dayjs(params.value, dataFormat, true).format(resultFormat);
    }
    else {
      return ""
    }
  }
  catch (e) {
    return ""
  }
}

export function weekendFormatter(params, dataFormat) {
  const weekend = dayjs(params.value, dataFormat).get("d");
  switch (weekend) {
    case 0:
      return "일";
    case 1:
      return "월";
    case 2:
      return "화";
    case 3:
      return "수";
    case 4:
      return "목";
    case 5:
      return "금";
    case 6:
      return "토";
  }
}

export function itemTypeFormatter(params) {
  let setItem;
  const data = params.data;
  const commGrpCd = data.commGrpcd;
  const itemType = data.itemType;
  switch (itemType) {
    case "Radio":
      setItem = ConfigRadio(params);
      break;
    case "Text":
      setItem = ConfigTextInput(params);
      break;
    case "Combo":
    case "Checkbox":
      setItem = ConfigCombo(params);
      break;
  }
  return setItem;
}
